import { render, staticRenderFns } from "./GroupCombine.vue?vue&type=template&id=0c654a54&"
import script from "./GroupCombine.vue?vue&type=script&lang=ts&"
export * from "./GroupCombine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports